import React, {useState} from "react";
import copy from "copy-to-clipboard";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import ZoomOutMapIcon from "@material-ui/icons/ZoomOutMap";

import CopyButton from "common_components/buttons/copy_button";
import {styled} from "styled-components";

interface Props {
  text: string;
}

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0.5em;
  height: 100%;
  flex-flow: column wrap;
  gap: 0.5em;
`;

export default function TextCopier({text}: Props) {
  const [showCopyButton, setShowCopyButton] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  return (
    <div
      onMouseEnter={() => setShowCopyButton(true)}
      onMouseLeave={() => setShowCopyButton(false)}
      style={{
        position: "relative",
        ...(showCopyButton ? {minHeight: "1.3em"} : {}),
      }}
    >
      <div
        style={{
          display: "flex",
          maxHeight: "10em",
          overflowY: "auto",
        }}
      >
        <pre
          style={{
            whiteSpace: "pre-wrap",
            margin: 0,
          }}
        >
          {text}
        </pre>
      </div>
      {showCopyButton && (
        <ButtonContainer>
          <CopyButton
            onCopyClick={() => copy(text)}
            hideCaption={true}
            iconStyle={{height: "0.8em", width: "0.8em"}}
          />
          <IconButton
            style={{padding: 0, height: "0.8em", width: "0.8em"}}
            onClick={() => {
              setShowPopup(true);
            }}
          >
            <ZoomOutMapIcon />
          </IconButton>
        </ButtonContainer>
      )}
      {showPopup && (
        <TextPopout
          text={text}
          handleClose={() => {
            setShowPopup(false);
          }}
        />
      )}
    </div>
  );
}

interface TextPopoutProps extends Props {
  handleClose: () => void;
}

function TextPopout({text, handleClose}: TextPopoutProps) {
  const [format, setFormat] = useState(true);
  const value = format ? formatValue(text) : text;
  return (
    <Dialog
      fullWidth={false}
      maxWidth="xl"
      open={true}
      onClose={handleClose}
      style={{}}
    >
      <DialogContent>
        <DialogContentText>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              margin: 0,
            }}
          >
            {value}
          </pre>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setFormat(!format)}>
          Turn formatting {format ? "off" : "on"}
        </Button>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function formatValue(value: string): string {
  if (value.startsWith('"')) {
    try {
      return JSON.stringify(JSON.parse(JSON.parse(value)), null, 2);
    } catch {
      return value.split("\\n").join("\n");
    }
  }
  return value;
}
